



import { defineComponent, PropType } from "@vue/composition-api";
import Editor, { Viewer } from "@toast-ui/editor";
import { EditorOptions, EditorType, PreviewStyle } from "@toast-ui/editor/types/editor";

export default defineComponent({
  name: "ToastUiViewer",
  props: {
    height: { type: String, default: "300px" },
    initialValue: { type: String, default: "" },
    initialEditType: { type: String as PropType<EditorType>, default: "markdown" },
    previewStyle: { type: String as PropType<PreviewStyle>, default: "vertical" },
    options: { type: Object as PropType<Partial<EditorOptions>> },
  },
  data() {
    return {
      viewer: null as Viewer | null,
    };
  },
  mounted() {
    const options = {
      ...this.options,
      initialEditType: this.initialEditType,
      initialValue: this.initialValue,
      height: this.height,
      previewStyle: this.previewStyle,
      el: this.$refs.toastuiEditorViewer as HTMLElement,
      viewer: true,
    };
    this.viewer = Editor.factory(options);
  },
});
